// extracted by mini-css-extract-plugin
export var avatarContainer = "_5b-0";
export var avatarTypingWave = "_5b-i";
export var gray = "_5b-f";
export var green = "_5b-c";
export var icon = "_5b-9";
export var image = "_5b-1";
export var lg = "_5b-6";
export var md = "_5b-5";
export var presenceDot = "_5b-b";
export var red = "_5b-d";
export var sm = "_5b-4";
export var status = "_5b-a";
export var typingDot = "_5b-h";
export var typingPill = "_5b-g";
export var xl = "_5b-7";
export var xs = "_5b-3";
export var xxl = "_5b-8";
export var xxs = "_5b-2";
export var yellow = "_5b-e";